import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";
import { useAppDispatch } from "@store";
import { openDialog } from "@store/dialogs";
import { MediaLibFolderCreateDialog } from "./folder";

interface IProps {
  folderParentId?: string | null;
  className?: string;
}

export const MediaLibAddFolderBtn = ({ folderParentId, className }: IProps) => {
  const dispatch = useAppDispatch();

  const handleNewFolder = () => {
    dispatch(
      openDialog({
        id: MediaLibFolderCreateDialog.dialogId,
        content: MediaLibFolderCreateDialog,
        props: {
          folderParentId,
        },
      }),
    );
  };

  return (
    <button
      type="button"
      className={cn(
        "tw-flex tw-cursor-pointer tw-items-center tw-space-x-2 tw-rounded-lg tw-border tw-border-dashed tw-border-blue-100 tw-bg-blue-50 tw-p-3 tw-text-[11px] tw-font-semibold tw-text-blue-500 tw-outline-none",
        className,
      )}
      onClick={() => handleNewFolder()}
    >
      <Icon icon="ri-add-line" className="tw-mr-1 tw-text-blue-500" />
      Add folder
    </button>
  );
};
